import { Box } from '@mui/material';
import React from 'react';

import Cross from '../../components/WsIcon/Cross';

interface EnhancedEndIconProps {
  endIcon: boolean;
  icon?: React.ReactElement;
  textColor?: string;
  endIconSize?: number;
}

const EnhancedEndIcon: React.FC<EnhancedEndIconProps> = ({
  endIcon,
  icon,
  textColor,
  endIconSize,
}) => {
  return endIcon ? (
    <Box sx={{ mr: 0.5, display: 'flex', alignItems: 'center' }}>
      {React.cloneElement(icon ?? <Cross />, {
        color: textColor,
        width: endIconSize,
        height: endIconSize,
      })}
    </Box>
  ) : null;
};

export default EnhancedEndIcon;
